import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { Geologists } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA,  MatDialogModule,  MatDialogRef} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-geolgical-sample-form-geologist',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
  ],
})
export class GeologicalSampleGeologistComponent {
  // Enum
  geologistList = Geologists;

  // Dialog setup
  dialogRef = inject<MatDialogRef<GeologicalSampleGeologistComponent>>(MatDialogRef);
  geologist = inject<string>(MAT_DIALOG_DATA);

  // Form setup
  name: FormControl = new FormControl(this.geologist, {
    validators: [Validators.required]
  });
  geologistForm: FormGroup = new FormGroup({
    geologist: this.name,
  });

  // Mode tracker
  isEdit: boolean;

  constructor() {
    this.isEdit = !!this.geologist;
  }

  public submit() {
    if (this.geologistForm.pristine || !this.geologistForm.valid) {
      return;
    }

    this.dialogRef.close(this.geologistForm.value.geologist);
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
